import { SVGProps, Ref, forwardRef } from 'react';

export const EmptySize64Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={64} height={64} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <rect x={-1} y={-1} width={66} height={66} stroke="currentColor" strokeWidth={2} />
            </g>
        </g>
    </svg>
));
EmptySize64Glyph.displayName = 'EmptySize64Glyph';
